import AppCheckbox from './AppCheckbox'

export default AppCheckbox